<template>
  <div class="item-container" :class="{ 'zoomed': zoomed, 'embed-video': embed && item.attributes.item_type == 'video' }">
    <div
      data-testid="blurred-image"
      v-if="item.attributes.view_limit_reached && !isOwner"
    >
      <!-- do not show the actual drop image -->
      <img src="images/blurred-drop.png">
    </div>
    <div class="content" :class="{'fixed': !zoomed}" v-else>
      <video-container v-if="item.attributes.item_type == 'video' || item.attributes.instant_video"
        :embed="embed"
        :id="item.id"
        :item="item"
        :poster="poster"
        :autoplay="autoplay"
        :is-owner="isOwner"
        :has-viewer-download-button="hasViewerDownloadButton"
        :host="host"
        :statid="statid"
        @videoEnded="onEnded($event)"
      ></video-container>

      <image-container
        v-else-if="item.attributes.item_type == 'image'"
        v-on:zoom="setZoom(true)"
        v-on:unzoom="setZoom(false)"
        :item="item"
      ></image-container>

      <pdf-container
        v-else-if="item.attributes.item_type == 'pdf'"
        :item="item"
        :can-download="canDownload"
        :show-download="showDownload"
        :cta="cta"
      ></pdf-container>

      <audio-container
        v-else-if="item.attributes.item_type == 'audio'"
        :item="item"
        :can-download="canDownload"
      ></audio-container>

      <generic-container
        v-else
        :item="item"
        :download-key-prompt-enabled="downloadKeyPromptEnabled"
        :generic-url="genericUrl"
      ></generic-container>
    </div>
  </div>
</template>

<script>
import VideoContainer from "./video_container";
import ImageContainer from "./image_container";
import PdfContainer from "./pdf_container";
import AudioContainer from "./audio_container";
import GenericContainer from "./generic_container";

export default {
  props: {
    embed: Boolean,
    item: Object,
    cta: Object,
    last_call_to_action: Object,
    use_last_settings: Boolean,
    isOwner: Boolean,
    host: String,
    statid: String,
    poster: String,
    autoplay: Boolean,
    hasViewerDownloadButton: Boolean,
    showDownload: Boolean,
    canDownload: Boolean,
    downloadKeyPromptEnabled: Boolean,
    genericUrl: String,
  },
  methods: {
    setZoom: function (value) {
      this.zoomed = value;

      // Unfortunately, we have to propagate again because the parent needs to hide the sidebar.
      // A future refactor (or rethink of the zoom feature) may take care of that.
      this.$emit(this.zoomed ? "zoom" : "unzoom");
    },
    onEnded: function(data) {
      this.$emit("video-ended", data);
    }
  },
  data() {
    return {
      zoomed: false,
      videoEnded: false,
    };
  },
  components: {
    VideoContainer,
    ImageContainer,
    PdfContainer,
    GenericContainer,
    AudioContainer,
  },
};
</script>

<style scoped lang="scss">
.item-container {
  position: relative;
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;

  .content {
    width: 100%;
  }
}

.item-container.zoomed {
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.item-container:not(.zoomed) {
  max-width: 103.13rem;
  margin: 0 auto;
}

.item-container.embed-video {
  max-width: 100%;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;

  .content {
    width: 100%;
    height: 100%;
  }
}

@media only screen and (max-width : 767px) {
  div.item-container {
    margin-bottom: 15px;
  }
}
</style>
